import React from 'react';

const Dashboard = React.lazy(() => import('../../components/pages/Dashboard'));

export const DashboardRouter = () => <Dashboard />;
